module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-02@2x.a9227a4d.jpg";